"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapNumber = exports.decideCircleColor = exports.setUpDate = void 0;
const next_components_text_info_n_1 = require("@gerenciatd/next.components.text-info-n");
const next_utils_common_1 = require("@gerenciatd/next.utils.common");
const enums_1 = require("./enums");
const isValidDate = (dateObj) => {
    if (Object.prototype.toString.call(dateObj) === '[object Date]') {
        // it is a date
        if (isNaN(dateObj.getTime())) {
            // d.valueOf() could also work
            // date is not valid
            return false;
        }
        // date is valid
        return true;
    }
    // not a date
    return false;
};
const setUpDate = (startDate, endDate) => {
    if (!startDate || !endDate) {
        return {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        };
    }
    const device = (0, next_utils_common_1.getDeviceInfo)();
    const { browser } = device;
    const { name: browserName } = browser;
    let strDateTimeIniNormalized = startDate || '';
    let strDateTimeFinNormalized = endDate || '';
    if (browserName === 'Safari' || browserName === 'Firefox') {
        strDateTimeIniNormalized = strDateTimeIniNormalized.replace(/-/g, '/');
        strDateTimeFinNormalized = strDateTimeFinNormalized.replace(/-/g, '/');
    }
    let dateIni = new Date(strDateTimeIniNormalized);
    const dateFin = new Date(strDateTimeFinNormalized);
    if (strDateTimeIniNormalized === '') {
        dateIni = new Date();
    }
    if (!isValidDate(dateIni)) {
        return {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        };
    }
    if (dateIni <= new Date()) {
        dateIni = new Date();
    }
    else {
        return {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        };
    }
    if (!isValidDate(dateFin)) {
        return {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        };
    }
    const firstDiff = dateFin.getTime() - dateIni.getTime();
    if (firstDiff < 0) {
        // warn
        return {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        };
    }
    const diff = new Date(firstDiff);
    // const years = diff.getUTCFullYear() - 1970; // Gives difference as year
    // let months = diff.getUTCMonth(); // Gives month count of difference
    const minutes = diff.getUTCMinutes();
    const days = diff.getUTCDate() - 1; // Gives day count of difference
    const seconds = diff.getUTCSeconds();
    const hours = diff.getUTCHours();
    // const totalSeconds = diff.getTime() / 1000;
    /* Tanslate to seconds */
    return {
        days,
        hours,
        minutes,
        seconds,
    };
};
exports.setUpDate = setUpDate;
const decideCircleColor = (colorTheme) => {
    switch (colorTheme) {
        case enums_1.COUNT_DOWN_DATE_TIMER_THEME.PURPLE:
            return {
                text: next_components_text_info_n_1.TEXT_INFO_COLOR.WHITE,
                counter: 'white',
                bg: 'rgba(255,255,255, 0.5)',
            };
        case enums_1.COUNT_DOWN_DATE_TIMER_THEME.PURPLE_REVERSE:
            return {
                text: next_components_text_info_n_1.TEXT_INFO_COLOR.PURPLE,
                counter: '#954b97',
                bg: 'rgba(182,183,183, 0.35)',
            };
        case enums_1.COUNT_DOWN_DATE_TIMER_THEME.WHITE:
            return {
                text: next_components_text_info_n_1.TEXT_INFO_COLOR.WHITE,
                counter: 'white',
                bg: 'rgba(255,255,255,0.5)',
            };
        case enums_1.COUNT_DOWN_DATE_TIMER_THEME.BLUE:
            return {
                text: next_components_text_info_n_1.TEXT_INFO_COLOR.GREY_6,
                counter: '#019DF4',
                bg: 'rgba(1,157,244,0.5)',
            };
        case enums_1.COUNT_DOWN_DATE_TIMER_THEME.BLUE_REVERSE:
            return {
                text: next_components_text_info_n_1.TEXT_INFO_COLOR.WHITE,
                counter: 'white',
                bg: 'rgba(255,255,255, 0.5)',
            };
        case enums_1.COUNT_DOWN_DATE_TIMER_THEME.BLUE_DARK:
            return {
                text: next_components_text_info_n_1.TEXT_INFO_COLOR.WHITE,
                counter: 'white',
                bg: 'rgba(255,255,255, 0.5)',
            };
        default:
            return {
                text: next_components_text_info_n_1.TEXT_INFO_COLOR.WHITE,
                counter: 'white',
                bg: 'rgba(255,255,255, 0.5)',
            };
    }
};
exports.decideCircleColor = decideCircleColor;
// Stackoverflow: https://stackoverflow.com/questions/10756313/javascript-jquery-map-a-range-of-numbers-to-another-range-of-numbers
const mapNumber = (number, inmin, inmax, outmin, outmax) => ((number - inmin) * (outmax - outmin)) / (inmax - inmin) + outmin;
exports.mapNumber = mapNumber;
//# sourceMappingURL=utils.js.map